/**
 * @generated SignedSource<<4f20a365546dc24899f230787fb932f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IconType = "ACTIVITY" | "AIRPLAY" | "ALERT_CIRCLE" | "ALERT_OCTAGON" | "ALERT_TRIANGLE" | "ALIGN_CENTER" | "ALIGN_JUSTIFY" | "ALIGN_LEFT" | "ALIGN_RIGHT" | "ANCHOR" | "APERTURE" | "ARCHIVE" | "ARROW_DOWN" | "ARROW_DOWN_CIRCLE" | "ARROW_DOWN_LEFT" | "ARROW_DOWN_RIGHT" | "ARROW_LEFT" | "ARROW_LEFT_CIRCLE" | "ARROW_RIGHT" | "ARROW_RIGHT_CIRCLE" | "ARROW_UP" | "ARROW_UP_CIRCLE" | "ARROW_UP_LEFT" | "ARROW_UP_RIGHT" | "AT_SIGN" | "AWARD" | "BAR_CHART" | "BAR_CHART_2" | "BATTERY" | "BATTERY_CHARGING" | "BELL" | "BELL_FILL" | "BELL_OFF" | "BLUETOOTH" | "BOLD" | "BOOK" | "BOOKMARK" | "BOOK_OPEN" | "BOX" | "BRIEFCASE" | "CALENDAR" | "CAMERA" | "CAMERA_OFF" | "CAST" | "CHECK" | "CHECK_CIRCLE" | "CHECK_SQUARE" | "CHEVRONS_DOWN" | "CHEVRONS_LEFT" | "CHEVRONS_RIGHT" | "CHEVRONS_UP" | "CHEVRON_DOWN" | "CHEVRON_LEFT" | "CHEVRON_RIGHT" | "CHEVRON_UP" | "CHROME" | "CIRCLE" | "CLIPBOARD" | "CLOCK" | "CLOUD" | "CLOUD_DRIZZLE" | "CLOUD_LIGHTNING" | "CLOUD_OFF" | "CLOUD_RAIN" | "CLOUD_SNOW" | "CODE" | "CODEPEN" | "CODESANDBOX" | "COFFEE" | "COLUMNS" | "COMMAND" | "COMPASS" | "COPY" | "CORNER_DOWN_LEFT" | "CORNER_DOWN_RIGHT" | "CORNER_LEFT_DOWN" | "CORNER_LEFT_UP" | "CORNER_RIGHT_DOWN" | "CORNER_RIGHT_UP" | "CORNER_UP_LEFT" | "CORNER_UP_RIGHT" | "CPU" | "CREDIT_CARD" | "CROP" | "CROSSHAIR" | "CUSTOM_CART" | "CUSTOM_CONCIERGE" | "CUSTOM_EXPERIENCES" | "CUSTOM_FEED" | "CUSTOM_PROFILE" | "CUSTOM_SHOP" | "DATABASE" | "DELETE" | "DISC" | "DIVIDE" | "DIVIDE_CIRCLE" | "DIVIDE_SQUARE" | "DOLLAR_SIGN" | "DOWNLOAD" | "DOWNLOAD_CLOUD" | "DRIBBBLE" | "DROPLET" | "EDIT" | "EDIT_2" | "EDIT_3" | "EXTERNAL_LINK" | "EYE" | "EYE_OFF" | "FACEBOOK" | "FAST_FORWARD" | "FEATHER" | "FIGMA" | "FILE" | "FILE_MINUS" | "FILE_PLUS" | "FILE_TEXT" | "FILM" | "FILTER" | "FLAG" | "FOLDER" | "FOLDER_MINUS" | "FOLDER_PLUS" | "FOR_YOU" | "FRAMER" | "FROWN" | "GIFT" | "GITHUB" | "GITLAB" | "GIT_BRANCH" | "GIT_COMMIT" | "GIT_MERGE" | "GIT_PULL_REQUEST" | "GLOBE" | "GRID" | "HARD_DRIVE" | "HASH" | "HEADPHONES" | "HEART" | "HELP_CIRCLE" | "HEXAGON" | "HOME" | "IMAGE" | "INBOX" | "INFO" | "INSTAGRAM" | "ITALIC" | "KEY" | "LAYERS" | "LAYOUT" | "LIFE_BUOY" | "LINK" | "LINKEDIN" | "LINK_2" | "LIST" | "LOADER" | "LOCK" | "LOG_IN" | "LOG_OUT" | "MAIL" | "MAP" | "MAP_PIN" | "MAXIMIZE" | "MAXIMIZE_2" | "MEH" | "MENU" | "MESSAGE_CIRCLE" | "MESSAGE_SQUARE" | "MESSAGE_SQUARE_FILL" | "MIC" | "MIC_OFF" | "MINIMIZE" | "MINIMIZE_2" | "MINUS" | "MINUS_CIRCLE" | "MINUS_SQUARE" | "MONITOR" | "MOON" | "MORE_HORIZONTAL" | "MORE_VERTICAL" | "MOUSE_POINTER" | "MOVE" | "MUSIC" | "NAVIGATION" | "NAVIGATION_2" | "OCTAGON" | "PACKAGE" | "PAPERCLIP" | "PAUSE" | "PAUSE_CIRCLE" | "PEN_TOOL" | "PERCENT" | "PHONE" | "PHONE_CALL" | "PHONE_FORWARDED" | "PHONE_INCOMING" | "PHONE_MISSED" | "PHONE_OFF" | "PHONE_OUTGOING" | "PIE_CHART" | "PLAY" | "PLAY_CIRCLE" | "PLUS" | "PLUS_CIRCLE" | "PLUS_SQUARE" | "POCKET" | "POWER" | "PRINTER" | "RADIO" | "REFRESH_CCW" | "REFRESH_CW" | "REPEAT" | "REWIND" | "ROTATE_CCW" | "ROTATE_CW" | "RSS" | "SAVE" | "SCISSORS" | "SEARCH" | "SEND" | "SERVER" | "SETTINGS" | "SHARE" | "SHARE_2" | "SHIELD" | "SHIELD_OFF" | "SHOPPING_BAG" | "SHOPPING_CART" | "SHUFFLE" | "SIDEBAR" | "SKIP_BACK" | "SKIP_FORWARD" | "SLACK" | "SLASH" | "SLIDERS" | "SMARTPHONE" | "SMILE" | "SPEAKER" | "SQUARE" | "STAR" | "STOP_CIRCLE" | "SUN" | "SUNRISE" | "SUNSET" | "TABLE" | "TABLET" | "TAG" | "TARGET" | "TERMINAL" | "THERMOMETER" | "THUMBS_DOWN" | "THUMBS_UP" | "TOGGLE_LEFT" | "TOGGLE_RIGHT" | "TOOL" | "TRASH" | "TRASH_2" | "TRELLO" | "TRENDING_DOWN" | "TRENDING_UP" | "TRIANGLE" | "TRUCK" | "TV" | "TWITCH" | "TWITTER" | "TYPE" | "UMBRELLA" | "UNDERLINE" | "UNLOCK" | "UPLOAD" | "UPLOAD_CLOUD" | "USER" | "USERS" | "USER_CHECK" | "USER_MINUS" | "USER_PLUS" | "USER_X" | "VIDEO" | "VIDEO_OFF" | "VOICEMAIL" | "VOLUME" | "VOLUME_1" | "VOLUME_2" | "VOLUME_2_FILL" | "VOLUME_X" | "VOLUME_X_FILL" | "WATCH" | "WIFI" | "WIFI_OFF" | "WIND" | "X" | "X_CIRCLE" | "X_OCTAGON" | "X_SQUARE" | "YOUTUBE" | "ZAP" | "ZAP_OFF" | "ZOOM_IN" | "ZOOM_OUT" | "%future added value";
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type TabType = "ACCOUNT" | "FORUM" | "FOR_YOU" | "NOTIFICATIONS" | "SHOP" | "WEB" | "%future added value";
export type NavigationPreviewQuery$variables = {
  id: string;
};
export type NavigationPreviewQuery$data = {
  readonly brand: {
    readonly appConfig: {
      readonly buildNavigation: {
        readonly id: string;
        readonly isGorgiasEnabled: boolean;
        readonly isTabBarTitleEnabled: boolean;
      };
      readonly buildTheme: {
        readonly buttonCartIcon: IconType | null;
        readonly logoUrl: string | null;
      };
      readonly id: string;
      readonly navigationItems: ReadonlyArray<{
        readonly children: ReadonlyArray<{
          readonly children: ReadonlyArray<{
            readonly index: number;
            readonly label: string;
            readonly localizations: ReadonlyArray<{
              readonly languageCode: KinnLanguageCode;
              readonly text: string;
              readonly url: string | null;
            }>;
            readonly url: string;
          }>;
          readonly index: number;
          readonly label: string;
          readonly localizations: ReadonlyArray<{
            readonly languageCode: KinnLanguageCode;
            readonly text: string;
            readonly url: string | null;
          }>;
          readonly url: string;
        }>;
        readonly index: number;
        readonly label: string;
        readonly localizations: ReadonlyArray<{
          readonly languageCode: KinnLanguageCode;
          readonly text: string;
          readonly url: string | null;
        }>;
        readonly url: string;
      }>;
      readonly nestedMenuItems: ReadonlyArray<{
        readonly children: ReadonlyArray<{
          readonly children: ReadonlyArray<{
            readonly destinationUrl: string | null;
            readonly index: number;
            readonly localizations: ReadonlyArray<{
              readonly languageCode: KinnLanguageCode;
              readonly text: string;
              readonly url: string | null;
            }>;
            readonly title: string;
          }>;
          readonly destinationUrl: string | null;
          readonly index: number;
          readonly localizations: ReadonlyArray<{
            readonly languageCode: KinnLanguageCode;
            readonly text: string;
            readonly url: string | null;
          }>;
          readonly title: string;
        }>;
        readonly destinationUrl: string | null;
        readonly index: number;
        readonly localizations: ReadonlyArray<{
          readonly languageCode: KinnLanguageCode;
          readonly text: string;
          readonly url: string | null;
        }>;
        readonly title: string;
      }>;
      readonly tabs: ReadonlyArray<{
        readonly customName: string;
        readonly customUrl: string | null;
        readonly icon: IconType;
        readonly id: string;
        readonly localizations: ReadonlyArray<{
          readonly languageCode: KinnLanguageCode;
          readonly text: string;
          readonly url: string | null;
        }>;
        readonly type: TabType;
      }>;
    };
    readonly id: string;
  };
};
export type NavigationPreviewQuery = {
  response: NavigationPreviewQuery$data;
  variables: NavigationPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buttonCartIcon",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BrandAppConfigBuildNavigationType",
  "kind": "LinkedField",
  "name": "buildNavigation",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGorgiasEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTabBarTitleEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedUrlType",
  "kind": "LinkedField",
  "name": "localizations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "NavigationItemType",
  "kind": "LinkedField",
  "name": "navigationItems",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NavigationItemType",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NavigationItemType",
          "kind": "LinkedField",
          "name": "children",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "NestedMenuItemType",
  "kind": "LinkedField",
  "name": "nestedMenuItems",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v9/*: any*/),
    (v12/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NestedMenuItemType",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        (v6/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NestedMenuItemType",
          "kind": "LinkedField",
          "name": "children",
          "plural": true,
          "selections": [
            (v11/*: any*/),
            (v12/*: any*/),
            (v6/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLBrandAppTabConfig",
  "kind": "LinkedField",
  "name": "tabs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customName",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigationPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildThemeType",
                "kind": "LinkedField",
                "name": "buildTheme",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigationPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildThemeType",
                "kind": "LinkedField",
                "name": "buildTheme",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f9b7f5c7c03b66edae9a18aab0a9a3b",
    "id": null,
    "metadata": {},
    "name": "NavigationPreviewQuery",
    "operationKind": "query",
    "text": "query NavigationPreviewQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    id\n    appConfig {\n      id\n      buildTheme {\n        buttonCartIcon\n        logoUrl\n        id\n      }\n      buildNavigation {\n        id\n        isGorgiasEnabled\n        isTabBarTitleEnabled\n      }\n      navigationItems {\n        index\n        label\n        localizations {\n          languageCode\n          text\n          url\n        }\n        url\n        children {\n          index\n          label\n          url\n          localizations {\n            languageCode\n            text\n            url\n          }\n          children {\n            index\n            label\n            url\n            localizations {\n              languageCode\n              text\n              url\n            }\n          }\n        }\n      }\n      nestedMenuItems {\n        title\n        localizations {\n          languageCode\n          text\n          url\n        }\n        destinationUrl\n        index\n        children {\n          title\n          destinationUrl\n          index\n          localizations {\n            languageCode\n            text\n            url\n          }\n          children {\n            title\n            destinationUrl\n            index\n            localizations {\n              languageCode\n              text\n              url\n            }\n          }\n        }\n      }\n      tabs {\n        id\n        type\n        customName\n        localizations {\n          languageCode\n          text\n          url\n        }\n        customUrl\n        icon\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3273f7960c45b0f166bf2ce8cf916e91";

export default node;
